import Vue from "vue";

Vue.prototype.$plantaremontaggio = [
  {
    key: "plantar_type",
    option: [
      //{ key: "Noone" },
      { key: "avvolg" },
      { key: "voltmolpro" },
      { key: "fisiolo" },
      { key: "plantar0" },
      { key: "plantar1" },
      { key: "plantar2" }
    ]
  },
  {
    key: "base_mat",
    material: "Moi"
  },
  {
    key: "surface_mat",
    material: "Sup_plan"
  },
  {
    key: "fin_dess",
    material: "Riv_plan"
  },
  {
    key: "pelotte",
    material: "Pelo"
  }
];
